import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow.png'
import _imports_1 from '@/assets/no-data.png'
import _imports_2 from '@/assets/confirm.png'


const _withScopeId = n => (_pushScopeId("data-v-2737107a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "org" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "org-list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_1
}
const _hoisted_6 = { class: "org-list-item-warp" }
const _hoisted_7 = { class: "org-name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "distance" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "hea-column not-data hea-justifyC" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/notData.png",
  alt: "",
  class: "not-data-img"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "not-data-title hea-justifyC",
  style: {"width":"100%"}
}, "无可选体检机构,请联系营销员", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_16 = {
  class: "overlay-wrapper-block",
  style: {"width":"100%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay-text" }, "请再次核对以下信息是否正确", -1))
const _hoisted_18 = { class: "physical-info" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "机构详情：", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "预约时间：", -1))
const _hoisted_21 = { class: "btn-list overlay-btn" }

import { computed, h, onMounted, reactive, ref } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import dayjs from 'dayjs';
    import { PhysicalService, OrgService } from 'src/services';
    import { useRouter, useRoute } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    import PageBack from 'src/components/common/page-back';
    import uScheduling from 'src/components/common/scheduling';
    import SelectCity from 'src/components/common/select-city';
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter();
    const route = useRoute();

    let state = reactive({
        showCity: false,
        filters:
        {
            cityName: "深圳市",
            longitude: 0,
            latitude: 0,
            taskId: null,
            key: ""
        }
    }) 

    let $pageList = ref(null)
    let showOverlay = ref(false)
    let showChangeOverlay = ref(false)
    let showDate = ref(false)
    let hospital = reactive({
        id: null,
        name:"",
    })
    let reserveDate = ref(null)

    const activeNames = ref([]);
    let detailInfo = ref({
        id: null,
        statusStr: "",
        memberName:"",
        invalidateTime:"",
        memberSexStr: "",
        policyNumbers: [],
        active: false,
        status: 1,
        physicalInfo:{
            hospitalId:0,
            packageId: 0,
            physicalItems:{},
            hospitalName: "",
            fullAddress: "",
            physicalDate: ""
        }
    })

    let orgList = ref([])

    /**
     * 当前位置
     * @private
     * @returns any
     */
    const location = computed({
        get ()
        {
            console.log(JSON.parse(localStorage.getItem("location")))
            return JSON.parse(localStorage.getItem("location")) || null;
        },
        set(value)
        {
        }
    })

    onMounted(()=>
    {
        
        if(location.value)
        {
            state.filters.cityName = (location.value as any).city || "";
            state.filters.latitude = (location.value as any).lat || "";
            state.filters.longitude = (location.value as any).lng || "";
        }
        if(route.query.id)
        {
            state.filters.taskId = route.query.id;
            getPackageHospitals()
            getphysicalDetail(route.query.id)
        }
        
    })

    /**
     * 获取机构列表
     */
    let getPackageHospitals = async ()=>
    {
        try {
            let { content: res } = await OrgService.instance.getPackageHospitals(state.filters);
            if(res.data)
            {
                orgList.value = res.data;
                
            }
        } catch (err) {
            Toast(err);
        }
    }

    let openMap = (item)=>
    {
        // let href = `http://uri.amap.com/marker?position=${detailInfo.value.physicalInfo.lng},${detailInfo.value.physicalInfo.lat}&name=${detailInfo.value.physicalInfo.hospitalName}&coordinate=gaode&callnative=1`;
        let href = `http://uri.amap.com/marker?position=${item.longitude},${item.latitude}&name=${item.name}&coordinate=gaode&callnative=1`;
        window.open(href);
    }
     
    /**
     * 获取体检任务 
     */
    let getphysicalDetail = async (id)=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getphysicalDetail(id);
            if(res.data)
            {
                detailInfo.value = res.data;
            }
        } catch (err) {
            Toast(err);
        }
    }
    /**
     * 选择机构 
     */
    let onSelectOrg = (item)=>
    {
        hospital.id = item.id;
        hospital.name = item.name;
        showDate.value = true;
    }

    /*
     * 选择城市
     * @private
     * @returns void
     */
    const onSelectCity = (city: string): void =>
    {
        state.filters.cityName = city;
        getPackageHospitals();
    }

    /**
     * 搜索 
     */
    let onSearch = (parameter)=>
    {
        $pageList.value.onRefresh()
    }

    /**
     * 确认日期 
     */
    let onDateConfirm = (date)=>
    {
        reserveDate.value = dayjs(date).format("YYYY/MM/DD");
        showOverlay.value = true;
   
    }

    /**
     * 预约体检 
     */
    let reservePackage = async (date)=>
    {

        let data=
        {
            id: route.query.id,
            hospitalId: hospital.id,
            hospitalName: hospital.name,
            physicalDate: reserveDate.value
        }


        try {
            let { content: res } = await PhysicalService.instance.reservePackage(data);
            router.push({name: "sucess", query:{id: detailInfo.value.id, type: "1"}});
           
        } catch (err) {
            Toast(err);
        }
    }
    

    

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      "show-action": "",
      class: "org-search",
      shape: "round",
      modelValue: _unref(state).filters.key,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).filters.key) = $event)),
      background: "#fff",
      onSearch: _unref(getPackageHospitals),
      placeholder: "请输入关键字"
    }, {
      action: _withCtx(() => [
        _createVNode(_component_van_icon, {
          class: "search-icon",
          size: "18",
          color: "#fff",
          name: "search",
          onClick: _unref(getPackageHospitals)
        }, null, 8, ["onClick"]),
        _createElementVNode("div", {
          class: "search-action",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).showCity = true))
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(state).filters.cityName), 1),
          _hoisted_2
        ])
      ]),
      "right-icon": _withCtx(() => []),
      "left-icon": _withCtx(() => []),
      _: 1
    }, 8, ["modelValue", "onSearch"]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgList), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "org-list-item",
          key: index
        }, [
          (item.logoPath)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.logoPath
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(item.name), 1),
            _createElementVNode("p", {
              class: "org-address",
              onClick: ($event: any) => (_unref(openMap)(item))
            }, [
              _createVNode(_component_van_icon, { name: "location-o" }),
              _createTextVNode(_toDisplayString(item.fullAddress), 1)
            ], 8, _hoisted_8),
            _createElementVNode("p", _hoisted_9, _toDisplayString(item.distance < 1?"<1": item.distance>99? ">99":item.distance) + "km", 1),
            _createElementVNode("button", {
              class: "btn-primary org-btn",
              onClick: ($event: any) => (_unref(onSelectOrg)(item))
            }, "立即预约", 8, _hoisted_10)
          ])
        ]))
      }), 128)),
      _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_14, 512), [
        [_vShow, _unref(orgList).length == 0]
      ])
    ]),
    _createVNode(_unref(uScheduling), {
      value: _unref(showDate),
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDate) ? (showDate).value = $event : showDate = $event)),
      onOnDateConfirm: _unref(onDateConfirm),
      userName: _unref(detailInfo).memberName,
      invalidateTime: _unref(detailInfo).invalidateTime,
      hospitalId: _unref(hospital).id,
      taskId: _unref(detailInfo).id
    }, null, 8, ["value", "onOnDateConfirm", "userName", "invalidateTime", "hospitalId", "taskId"]),
    _createVNode(_unref(SelectCity), {
      value: _unref(state).showCity,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).showCity) = $event)),
      onOnSelectCity: onSelectCity
    }, null, 8, ["value"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showOverlay),
      class: "notice-overlay",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(showOverlay) //@ts-ignore
 ? showOverlay.value = false : showOverlay= false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", null, [
                _hoisted_19,
                _createElementVNode("div", null, _toDisplayString(_unref(hospital).name), 1)
              ]),
              _createElementVNode("li", null, [
                _hoisted_20,
                _createElementVNode("div", null, _toDisplayString(_unref(reserveDate)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "btn-cancel van-hairline--surround",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showOverlay) //@ts-ignore
 ? showOverlay.value = false : showOverlay = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(reservePackage) && _unref(reservePackage)(...args)))
              }, "确认")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})